import React from "react";
import { useStaticQuery, graphql, Script } from "gatsby";
import { Helmet } from "react-helmet";
// import { Navbar, Container, Row, Col, Nav } from "react-bootstrap";
// import { Link } from "gatsby";
import Header from "../components/header";
import ESHeader from "../components/headerES";
import Footer from "../components/footer";
import ESFooter from "../components/footerES";

import "../scss/application.scss";
import Popup from "./popup";
import PopupEs from "./popupEs";

// import { useEffect } from "react";

function fetchFooter(language) {
  if (language === "spanish") {
    return <ESFooter />;
  }
  return <Footer />;
}

function fetchHeader(language) {
  if (language === "spanish") {
    return <ESHeader />;
  }
  return <Header />;
}

function fetchPopup(language) {
  if (language === "spanish") {
    return <PopupEs />;
  }
  return <Popup />;
}

const Layout = ({ helmet = {}, meta = {}, children, location, language }) => {
  const data = useStaticQuery(
    graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
            description
            siteUrl
            image
            site_name
          }
        }
      }
    `
  );

  // assign overrides from props
  // let { title, description, siteUrl, image, site_name } =
  //   data.site.siteMetadata || {};

  // TODO: assign defaults if necessary

  let mergedMeta = {
    // title,
    // description,
    // siteUrl,
    // image,
    // site_name,
    ...data.site.siteMetadata,
    ...meta,
  };

  // parse meta fields
  const metaFields = [
    "description",
    "keywords",
    "robots",
    "og:title",
    "og:description",
    "og:image",
    "og:url",
    "og:site_name",
    "twitter:title",
    "twitter:description",
    "twitter:image",
  ];
  let metaTags = [{ name: "twitter:card", content: "summary_large_image" }];
  for (let t of metaFields) {
    // metaFields.map((t) => {
    const content = mergedMeta[t.replace(/^(og|twitter):/, "")];
    if (content) {
      let tag = { content };
      if (t.match(/^og:/)) {
        tag.property = t;
      } else {
        tag.name = t;
      }
      metaTags.push(tag);
    }
    // });
  }

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: "en",
        }}
        title={mergedMeta.title}
        {...helmet}
        meta={metaTags}
        // titleTemplate={`%s | ${site.siteMetadata.title}`}

        link={[
          {
            rel: "stylesheet",
            type: "text/css",
            href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css",
          },
          {
            rel: "stylesheet",
            type: "text/css",
            href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css",
          },
          {
            rel: "stylesheet",
            href: "https://use.typekit.net/kpx1etp.css",
          },
          {
            rel: "stylesheet",
            href: "https://fast.fonts.net/cssapi/7c26f4cc-b170-40c5-8176-203479668fa9.css",
          },
          //   {
          //     rel: 'apple-touch-icon',
          //     sizes: '180x180',
          //     href: '/images/webclip/apple-touch-icon.png',
          //   },
          {
            rel: "icon",
            type: "image/png",
            sizes: "32x32",
            href: "/images/favicon-32x32.png",
          },
          {
            rel: "icon",
            type: "image/png",
            sizes: "16x16",
            href: "/images/favicon-16x16.png",
          },
          //   {
          //     rel: 'mask-icon',
          //     href: '/images/webclip/safari-pinned-tab.svg',
          //   },
        ]}
      >
        
        <script id="ketch-js" type="text/javascript">{`
          !function(){window.semaphore=window.semaphore||[],window.ketch=function(){window.semaphore.push(arguments)};var e=document.createElement("script");e.type="text/javascript",e.src="https://global.ketchcdn.com/web/v3/config/corporate/mentalhealthaction_network/boot.js",e.defer=e.async=!0,document.getElementsByTagName("head")[0].appendChild(e)}();
        `}</script>
        <script id="optanon-js" type="text/javascript">{`
            (function(a){
              var w=window,b='cbsoptanon',q='cmd',r='config';
              w[b] = w[b] ? w[b] : {};
              w[b][q] = w[b][q] ? w[b][q] : [];
              w[b][r] = w[b][r] ? w[b][r] : [];
              
              a.forEach(function(z){
                w[b][z] = w[b][z] || function(){
                  var c=arguments;
                  w[b][q].push(function(){
                    w[b][z].apply(w[b],c);
                  })
                }
              });
            })(["onScriptsReady","onAdsReady"]);
        `}</script>

        <script src="https://cdn.privacy.paramount.com/dist/optanon-v2.0.0.js" async></script>

        <script id="tag-manager-js" type="text/javascript">{`  
            function loadScript(url) {
              var script_tag = document.createElement('script');
              script_tag.setAttribute('src', url);
              document.head.appendChild(script_tag) 
              }
            
              cbsoptanon.cmd.push(function(cmp) {
                cmp.ot.performanceAllowed(function(allowed) {
                  if (allowed) {
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','GTM-TGC3B82');
                  }
                });
              });
          `}</script>
      </Helmet>

      {fetchHeader(language)}

      <main>{children}</main>

      {/* <PoweredBy /> */}

      {fetchFooter(language)}
      {/* <Footer /> */}
      {fetchPopup(language)}
    </>
  );
};
export default Layout;
